<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1FW4xE/tc-custom/9781467765831.jpg?1704717877688" alt="This image is the cover for the book Why Is the Statue of Liberty Green?, Our American Symbols"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Why Is the Statue of Liberty Green?, Our American Symbols
      </h1>
      <p class="bookDescription body article font2">
        <p>Do you know that the Statue of Liberty hasn't always looked green? Or that the first torch had to be replaced? Lady Liberty has been an important US symbol for more than one hundred years. Join Mrs. Bolt's class as they visit the statue and learn where the statue came from, how she was built, and what American ideas she represents.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Martha E. H. Rustad, Holli Conger
      </h2>
      
      <p class="authorDescription body article"><B>Martha E. H. Rustad</B> is the author of more than two hundred nonfiction children's books, on topics ranging from snowflakes to termites to the Statue of Liberty. She lives with her family in Brainerd, Minnesota.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Millbrook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b4691da